import { ignoreElements, pipe, tap } from 'rxjs';
import { type Navigate } from '@/slices/app/types';
import router from '@/routes';

export const navigate = (params?: Navigate) =>
  pipe(
    tap((action?: any) => {
      const to = params?.to || action?.payload?.to;
      const options = params?.options || action?.payload?.options;

      if (!to) return;

      router.navigate(to, options);
    }),
    ignoreElements(),
  );
